import { useEffect } from 'preact/hooks'
import { useSearch } from 'wouter-preact'

import { Typography } from 'components'
import { userInformationState, getPlans, getProjects, username } from 'state'
import { LinksActions } from 'types'

import {
	CollaboratorInvitationSuccessModal,
	HighlightsSection,
	HomeRightSidebar,
	TrendingSection,
	GettingStartedCard
} from './components'
import {
	acceptedProjectState,
	handleAcceptCollaboratorInvitation,
	handleCloseCollaboratorInvitationSuccessModal,
	isCollaboratorInvitationSuccessModalOpen,
	isNewSmartContractModalOpen,
	setSmartContractModalState
} from './state'
import { NewSmartContractModal } from '../components/new_smart_contract_modal'

const HomePage = () => {
	const params = useSearch()

	useEffect(() => {
		const searchParams = new URLSearchParams(params)
		const projectId = searchParams.get('project-id')
		const action = searchParams.get('action')

		if (projectId && action === LinksActions.AcceptTeamInvitation) {
			handleAcceptCollaboratorInvitation(projectId)
		} else if (userInformationState.peek()!.onboarded === false) {
			getPlans()
		}

		getProjects()
	}, [params])

	return (
		<div class='flex w-full gap-10'>
			<CollaboratorInvitationSuccessModal
				isModalOpen={isCollaboratorInvitationSuccessModalOpen.value}
				onCloseModal={handleCloseCollaboratorInvitationSuccessModal}
				projectName={acceptedProjectState.value.name}
			/>

			<div class='flex-1'>
				{isNewSmartContractModalOpen.value && (
					<NewSmartContractModal
						isOpen={isNewSmartContractModalOpen.value}
						onClose={() => setSmartContractModalState(false)}
					/>
				)}

				{/* Welcome Section */}
				<section class='mb-8'>
					<Typography
						color='text-black-100'
						text={`Welcome, ${username}`}
						variant='h2'
					/>
					<Typography
						color='text-black-200'
						text='Catch up on the latest.'
						variant='text2'
					/>
				</section>

				<GettingStartedCard />

				{/* Highlights Section */}
				<HighlightsSection />

				{/* Trending Section */}
				<TrendingSection />
			</div>

			<HomeRightSidebar />
		</div>
	)
}

export { HomePage }
